module.exports = __webpack_public_path__ + "static/media/white_logo.4e65e29b.png";